import { favorites, prefectures } from '@/externals/gyym/user'
import { FacilityId } from './types'
// import dayjs from 'dayjs';
import { Prefecture } from '../Facilities'

export const listFavoriteFacilities = async (
  params?: favorites.ListFavoriteFacilitiesParams
) => {
  return await favorites.listFacilities(params)
}

export const listFavoriteTimetables = async (
  params?: favorites.ListFavoriteTimetableParams
) => {
  return await favorites.listTimetables(params)
}

export const listFavoriteSearchAttributes = async () => {
  const attributes = await favorites.listSearchAttributes()

  return {
    ...attributes,
    areas: attributes.areas.map((area) => {
      const prefecture = prefectures.getSync(area.prefectureId) as Prefecture
      return {
        ...area,
        prefectureName: prefecture.name,
      }
    }),
  }
}

export const markFacilityAsFavorite = async (id: FacilityId) => {
  return await favorites.addFacility(id)
}

export const unmarkFacilityAsFavorite = async (id: FacilityId) => {
  return await favorites.removeFacility(id)
}
